/* eslint-disable no-use-before-define, no-unused-vars */
import React from "react";
import {
  ActivityIndicator,
  Button as RNButton,
  Text,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import MenuButton from "../components/MenuButton";
import { initBoxConnection } from "../redux/actions/box";
import Phone from "../utils/Phone";
import { errorColors, RepositColours, RepositStyles } from "../utils/styles";
import goTo from "../utils/goTo";
import WebHeading from "../components/WebHeading";
import Icon from "react-native-vector-icons/FontAwesome";

const questionCircle = (
  <Icon name="warning" size={20} color={errorColors.orange} />
);

const mapStateToProps = (state) => ({
  box: state.box,
});

const mapDispatchToProps = (dispatch) => {
  return {
    remediationActions: bindActionCreators({ initBoxConnection }, dispatch),
  };
};

class InternetCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fail: false,
      hardFail: false,
    };
  }
  static navigationOptions = {
    headerRight: <MenuButton />,
    title: "Box Replacement",
  };

  componentDidMount() {
    // setTimeout(this.failing, 3000)
    setTimeout(
      this.props.remediationActions.initBoxConnection,
      1000,
      this.props.box.serialNumber
    );
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.box.connection.initConnectionStatus !== "ONLINE" &&
      nextProps.box.connection.initConnectionStatus === "ONLINE"
    ) {
      this.nav();
    }
  }

  nav = () => {
    goTo(this.props.navigation, "AddressValidation");
  };

  failing = () => {
    this.setState({ fail: true });
  };

  rescan = () => {
    this.props.remediationActions.initBoxConnection(
      this.props.box.serialNumber
    );
  };

  render() {
    console.log(this.props);
    const status = this.props.box.connection.initConnectionStatus;
    return (
      <View style={RepositStyles.wrapper}>
        <WebHeading title="Box Replacement" />
        <View
          style={{
            flex: 1,
            backgroundColor: status !== "OFFLINE" ? "#3CA5D5" : "white",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <View style={{ flex: 1, maxWidth: 500, justifyContent: "center" }}>
            <View>
              {status === "OFFLINE" ? null : (
                <ActivityIndicator
                  size="large"
                  color={
                    status !== "OFFLINE" ? "white" : RepositColours.textGrey
                  }
                />
              )}
            </View>
            <View style={{ marginTop: 20 }}>
              <Text
                style={{
                  ...RepositStyles.headerText,
                  marginTop: 20,
                  marginBottom: 10,
                  color: status !== "OFFLINE" ? "white" : errorColors.orange,
                  textAlign: "center",
                }}
              >
                {status !== "OFFLINE" ? null : questionCircle}
                {status !== "OFFLINE"
                  ? "Connecting to Reposit Box"
                  : " We're Having Trouble Connecting"}
              </Text>
              <Text
                style={{
                  ...RepositStyles.paragraphText,
                  textAlign: "center",
                  color:
                    status !== "OFFLINE" ? "white" : RepositColours.textGrey,
                }}
              >
                {status !== "OFFLINE"
                  ? "Please wait"
                  : "Here's some things you can try:"}
              </Text>
              {status !== "OFFLINE" ? null : (
                <View>
                  <Text
                    style={{ ...RepositStyles.paragraphText, marginTop: 15 }}
                  >
                    1. Check that the USB network connection is plugged in.
                  </Text>
                  <Text
                    style={{ ...RepositStyles.paragraphText, marginTop: 10 }}
                  >
                    2. Ensure the Reposit Box has been powered on for a few
                    minutes. It can take up to 5 minutes for the Reposit Box to
                    establish a connection.
                  </Text>
                  <Text
                    style={{ ...RepositStyles.paragraphText, marginTop: 10 }}
                  >
                    Once you've tried the above please tap Reconnect to attempt
                    connecting
                  </Text>
                  <View style={{ marginVertical: 20 }}>
                    <RNButton
                      title="Reconnect"
                      onPress={() => this.rescan()}
                      color={RepositColours.blue}
                    />
                  </View>
                  <Text
                    style={{ ...RepositStyles.paragraphText, marginTop: 10 }}
                  >
                    Still having trouble?
                    <Phone> It's time to call Reposit on</Phone>
                  </Text>
                </View>
              )}
            </View>
          </View>
        </View>
      </View>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(InternetCheck);



// WEBPACK FOOTER //
// ./src/containers/InternetCheck.js